import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

interface DocumentNumberLinkProps {
  to: string;
  children: React.ReactNode;
  /** When false the number renders as plain text (no navigation affordance). */
  canOpen?: boolean;
  className?: string;
}

/**
 * Permission-aware document number link for list tables.
 * Renders a styled react-router Link when the user may open the document,
 * otherwise plain readable text.
 */
export default function DocumentNumberLink({
  to,
  children,
  canOpen = true,
  className,
}: DocumentNumberLinkProps) {
  if (!canOpen) {
    return <span className={cn("font-mono", className)}>{children}</span>;
  }

  return (
    <Link
      to={to}
      className={cn(
        "font-mono text-primary hover:underline font-medium cursor-pointer",
        className,
      )}
    >
      {children}
    </Link>
  );
}
